const stateList = {
    "JHR": "Johor",
    "KDH": "Kedah",
    "KTN": "Kelantan",
    "MLK": "Melaka",
    "NSN": "Negeri Sembilan",
    "PHG": "Pahang",
    "PRK": "Perak",
    "PLS": "Perlis",
    "PNG": "Pulau Pinang",
    "SBH": "Sabah",
    "SWK": "Sarawak",
    "SGR": "Selangor",
    "TRG": "Terengganu",
    "KUL": "Kuala Lumpur",
    "LBN": "Labuan",
    "PJY": "Putrajaya",
}

export default stateList